/* button.tsx generated by @compiled/babel-plugin v0.17.1 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import React from "react";
import theme from "../theme";
var _8 = "._irr31ojv:hover{background-color:rgba(205,214,244,.1)}";
var _7 = "._19itglyw{border:none}";
var _6 = "._11q71j28{background:transparent}";
var _5 = "._1wyb1crf{font-size:9pt}";
var _4 = "._k48p1nn1{font-weight:400}";
var _3 = "._otyr1y44{margin-bottom:4px}";
var _2 = "._19pk1y44{margin-top:4px}";
var _ = "._syaz1ds0{color:#b4befe}";
var buttonStyles = null;
var Button = function Button(_ref) {
  var onClick = _ref.onClick,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _2, _3, _4, _5, _6, _7, _8]), /*#__PURE__*/React.createElement("button", {
    onClick: onClick,
    className: ax(["_syaz1ds0 _19pk1y44 _otyr1y44 _k48p1nn1 _1wyb1crf _11q71j28 _19itglyw _irr31ojv"])
  }, children));
};
export default Button;